import React from 'react';
import {Row, Col} from 'antd';

import Card, { CardItem } from './Card';
import AMD from '../../../common/amd/AMD';

import { getCategoryText } from "../../../helpers/parsers";

const Products = ({ application }) => {
    const { cooperationName, purchasedProducts } = application;

    const total = purchasedProducts.reduce(function(a, b) { return a + b.price; }, 0);

    return (
        <Card title='Ձեռքբերվող ապրանքներ'>
            <div className='rounded-container mt-1'>
                <Row type='flex' justify='space-between' className='table-header-big big border-b-white'>
                    <Col span={8}>
                        <CardItem
                            style={{ padding: '24px' }}
                            name='Համագործակցություն'
                            value={
                                <div style={{ height: '100%' }} className='big-purple-text elipsis'>
                                    {cooperationName || '-'}
                                </div>
                            }
                        />
                    </Col>
                    <Col span={8}>
                        <CardItem
                            style={{ padding: '24px' }}
                            name='Ապրանքներ'
                            value={<div className='big-purple-text'>{purchasedProducts.length || '-'}</div>}
                        />
                    </Col>
                    <Col>
                        <CardItem
                            style={{ padding: '24px' }}
                            name='Ընդամենը'
                            value={
                                <div style={{ textAlign: 'right' }} className='big-purple-text'>
                                    <AMD value={ total } />
                                </div>
                            }
                        />
                    </Col>
                </Row>
                <div>
                    <div className='table-header'>
                        <Row justify='space-between' className='h-100'>
                            <Col span={6} className='m-auto'>Ապրանքատեսակ</Col>
                            <Col span={6} className='m-auto'>Ապրանք</Col>
                            <Col span={6} className='m-auto'>imei կոդ</Col>
                            <Col className='m-auto'>Միավորի գին</Col>
                        </Row>
                    </div>
                    <div>
                        {purchasedProducts.map((product, i) => {
                            return <Row className='table-row' key={i} justify='space-between'>
                                <Col span={6} className='m-auto elipsis'>{getCategoryText(product.category)}</Col>
                                <Col span={6} className='m-auto elipsis'>{product.productName}</Col>
                                <Col span={6} className='m-auto'>{product.imeiCode}</Col>
                                <Col className='m-auto'><AMD value={product.price}/></Col>
                            </Row>
                        })}
                    </div>
                </div>
            </div>
        </Card>
    )
};

Products.propTypes = {};

export default Products;